import React from 'react';
import News from '../news';

const InstitutionalSupporNews = () => {

  return (
    <News
    pageTitle="Insitutional Support"
    metaTitle="Insitutional Support - FORLAND"
    bannerImage="/assets/images/bg1.png"
    to='/institutional-support'
    category='Institutional Support'
  />
  );
};

export default InstitutionalSupporNews;